import axiosClient from "./AxiosConfig";
import axios from "axios";

const getHostName = () => process.env.REACT_APP_HOST_NAME_BACKEND;

const logoutClient = axios.create({
  baseURL: `${getHostName()}/api/v1/`,
  timeout: 30000,
  withCredentials: true
});

const AuthService = {

  async authenticate(email, password, deviceId) {
    return await axiosClient.post("/auth/login", { email, password, deviceId });
  },

  async googleAuthenticate(token) {
    return await axiosClient.post("/auth/google", { token });
  },

  async logout() {
    await logoutClient.get('/auth/logout');
  }
};

export default AuthService;
